import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'lokos-yes-no-toggle',
    templateUrl: './yes-no-toggle.component.html',
    styleUrl: './yes-no-toggle.component.scss',
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => YesNoToggleComponent),
            multi: true,
        },
    ],
})
export class YesNoToggleComponent implements ControlValueAccessor {
    @Input() label = '';
    @Input() disabled = false;

    value: boolean | null = null;
    private onChange: (value: boolean | null) => void = () => undefined;
    private onTouched: () => void = () => undefined;

    writeValue(value: boolean | null): void {
        this.value = value;
    }

    registerOnChange(fn: (value: boolean | null) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    select(option: boolean) {
        if (this.disabled) return;
        this.value = option;
        this.onChange(this.value);
        this.onTouched();
    }
}
